module.exports = "/_next/static/images/amex@3x-2500542de03401e2d38eda0d3d671321.png";